import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: ('#f27f04'),
        success: ('#1976d2')
      }
    }
  },
  icons: {
    iconfont: "mdi"
  }
});
